const fr_FR = {
  Name: 'Nom',
  'First name': 'Prénom',
  'Receiver email': 'Email de réception',
  'Sender email': 'Email du résident',
  Object: 'Objet',
  Content: 'Contenu',
  Hello: 'Bonjour ',
  "let's go": 'On y va',
  Email: 'Email',
  Password: 'Mot de passe',
  'My next actions': 'Mes prochaines actions',
  House: 'Maison',
  'Period of stay': 'Periode de séjour',
  Profil: 'Profil',
  'My profile': 'Mon profil',
  'Need help ?': "Besoin d'aide ?",
  Settings: 'Paramètres',
  'Sign out': 'Se déconnecter',
  'Privacy Policy': 'Politique de confidentialité',
  'Legal Notice': 'Mentions légales',
  'Centers of interest': "Centres d'intérêt",
  Notifications: 'Notifications',
  'Receive push notifications': 'Autoriser les notifications',
  'Receive email notifications': 'Recevoir les notifications par email',
  'Receive push mobile notifications': 'Recevoir les notifications mobile',
  'Profile privacy': 'Confidentialité du profil',
  'Level of confidentiality': 'Niveau de confidentialité',
  'Confidentiality CIUP': 'CIUP',
  'Confidentiality House': 'Ma maison',
  'Confidentiality Private': 'Privé',
  'Confidentiality CIUP description':
    'En sélectionnant "CIUP", tous les membres du portail peuvent voir votre profil (dans la limites des éléments que vous souhaitez partager)',
  'Confidentiality House description':
    'En sélectionnant "Maison", seuls les membres de votre maison peuvent voir votre profil (dans la limites des éléments que vous souhaitez partager)',
  'Confidentiality Private description':
    'En sélectionnant "Privé", aucun membre de la Cité ne pourra avoir accès à votre profil',
  'Show my profile picture': 'Afficher mon image de profil',
  'Show my phone number': 'Afficher mon numéro de téléphone',
  'Show my email address': 'Afficher mon adresse mail',
  'Show my house': 'Afficher ma maison',
  'Show my name': 'Afficher mon nom',
  'Application language': "Language de l'application",
  French: 'Français',
  English: 'Anglais',
  'All news': 'Toutes les actualités',
  News: 'Actus',
  'All events': 'Les événements',
  Events: 'Événements',
  'of the house': 'de la maison',
  Services: 'Services',
  About: 'À propos',
  'Contact House': 'Contacter la maison',
  'House Services': 'Les services et démarches',
  'Update my profile picture': 'Mettre à jour ma photo de profil',
  Cancel: 'Annuler',
  'From Photos': 'Bibliothèque de photos',
  'Take Picture': 'Prendre une photo',
  'Please allow access to the camera in the app settings on your phone':
    "Veuillez autoriser l'accès à l'appareil photo dans les règlages de l'application de votre téléphone",
  'Please allow access to the photo library in the app settings on your phone':
    "Veuillez autoriser l'accès à votre bibliothèque photo dans les règlages de l'application de votre téléphone",
  'Phone number': 'Téléphone',
  Mail: 'Mail',
  '404 error': 'Erreur 404',
  'Page not found': 'Page non trouvée.',
  'Sorry find': 'Nous ne pouvons accéder à la page demandée',
  'Go back home': "Retour à l'accueil",
  'Edit those informations': 'Modifier ces informations',
  '[Residents Portal] Request to update my email address':
    '[Portail résidents] Demande de mise à jour de mon adresse email',
  'Go back': 'Retour',
  Pages: 'Pages',
  'See my profile': 'Voir mon profil',
  Logout: 'Déconnexion',
  'The Residents Portal team will help you by email : ':
    "L'équipe du Portail des résidents vous aide par email : ",
  'Information saved successfully': 'Informations enregistrée avec succès',
  'See the news': "Voir l'article",
  'Coming Soon': 'Bientôt disponible !',
  Citescope: "Voir l'événement sur citescope",
  'See more': 'Tout voir',
  'Enter phone number': 'Numéro de téléphone',
  'Not loded yet': 'Pas encore chargé',
  Place: 'Lieu :',
  To: 'au',
  'Event Place': "Lieu de l'événement",
  'Event Places': "Lieux de l'événement",
  'Useful infos': 'Infos pratiques',
  Directory: 'Mon annuaire',
  'Mobile notifs are blocked':
    "Les notifications sont bloquées. Veuillez autoriser l'envoi de notification dans les réglages de votre appareil !",
  'Web notifs are blocked':
    "Les notifications sont bloquées. Veuillez autoriser l'envoi de notification dans les paramètres de votre navigateur !",
  Loading: 'Chargement...',
  Block: 'Bloquer',
  Unblock: 'Débloquer',
  preventionBlock: 'Êtes-vous sûr de vouloir bloquer cet utilisateur ?',
  preventionUnblock:
    'Êtes-vous sûr de vouloir débloquer cet utilisateur ? (il aura de nouveau accès à vos information de contact)',
  'Contact request': ' demande de contact',
  'Contact requests': ' demandes de contact',
  'Contact request mobile': 'DEMANDE DE MISE EN RELATION',
  'Contact requests mobile': 'DEMANDES DE MISE EN RELATION',
  'Contact request title': 'Demande de contact',
  'No new contact request': "Vous n'avez pas de nouvelle demande de contact",
  'Friend Request Action Success #request': 'La demande envoyée avec succès',
  'Friend Request Action Success #delete': 'La demande a été supprimée',
  'Friend Request Action Success #refuse': 'Demande refusée',
  'Friend Request Action Success #accept': 'Demande acceptée',
  'Friend Request Action Failed':
    "Quelque chose ne s'est pas bien passé, réessayez plus tard ...",
  'Friend Request Action Label #request': 'Ajouter',
  'Friend Request Action Label #delete': 'Supprimer',
  'Friend Request Action Label #prompt': 'Répondre',
  'Friend Request Action Label #accept': 'Accepter',
  'Friend Request Action Label #refuse': 'Refuser',
  'Form Submited': 'Votre demande à bien été transmis au service concerné',
  'Form Not Submited':
    "Votre demande n'a pas pu être transmise, veuillez réessayer",
  'Form unknown error': 'Vous ne pouvez plus participer à ce formulaire',
  'Form well submitted': 'Le formulaire a été envoyé - Merci',

  FAQ: 'FAQ',
  'Enter the object': "Saisir l'objet",
  'Enter your request here': 'Saisissez votre demande à cette endroit',
  Map: 'Carte',
  'Search #all': 'Tous',
  'Search #news': 'Actus',
  'Search #events': 'Événements',
  'Search #services': 'Services',
  'Search #users': 'Annuaire',
  'Search #places': 'Lieux',
  'Search in library': 'Rechercher dans la bibliothèque',
  Search: 'Rechercher',
  'Search Reset': 'Effacer',
  'See All Results': 'Voir tous les résultats',
  'No Results': 'Aucun résultat pour cette catégorie',
  'Search More': 'Voir plus',
  Searching: 'Recherche en cours ...',
  'My checklists': 'Mes checklists',
  'Todo Checklists': 'Mes checklists à faire',
  'Done Checklists': 'Mes checklists terminées',
  'No checklist': 'Aucune checklist pour le moment',
  'Error loading entries': 'Erreur de chargement des entrées',
  'The checklist ends in': 'Il vous reste',
  day: 'jour',
  default: '',
  'assimile-resident': 'Assimilé Résident',
  'assimile-salarie': 'Assimilé Salarié',
  resident: 'Résident',
  employee: 'Salarié',
  other: 'Autre',
  api: 'Api',
  Identification: 'Identification',
  'Identification card': 'Carte Identification',
  'QR code Identification': 'QR code Identification',
  'QR code identification': "QR code d'identification",
  'Sports QR code': 'QR code Sport',
  'QR code sports offer': 'QR code offre sportive',
  'Show your resident card in case of control, and scan one QR codes to access the facilities.':
    'Présentez votre carte de résident en cas de contrôle, et scannez l’un des QR codes pour accéder aux installations.',
  'No interests': "Aucun centre d'intérêt trouvé",
  'Unavailable Datas': 'Données indisponibles',
  Filter: 'Filtrer',
  hello: 'Bonjour',
  'Config profile': 'Nous allons vous aider à configurer votre profil.',
  'Start with language':
    'Pour commencer, merci de choisir la langue que vous souhaitez utiliser.',
  'Profile picture': 'Photo de profil',
  'Profile picture info':
    'Afin de vous identifier sur le campus, merci de vous prendre en photo. Cette photo sera affichée sur votre carte de résident dématérialisée.',
  'Get started !': 'Commencer !',
  Next: 'Suivant',
  "Let's go !": "C'est parti !",
  'My curriculum': 'Mon cursus',
  'My curriculum description':
    'Afin de renforcer votre profil résidident, pourriez-vous ajouter les différentes informations liées à votre cursus.',
  Formation: 'Formation',
  'Formation Placeholder': 'Recherchez votre formation',
  Discipline: 'Discipline',
  'Discipline Placeholder': 'Recherchez votre discipline',
  'Study Year': "Année d'étude",
  'Study Year Placeholder': "Recherchez votre année d'étude",
  Establishment: 'Établissement',
  'Establishment Placeholder': 'Recherchez votre établissement',
  'Notif description':
    "Les notifications vous permettent de recevoir les informations importantes du campus (fermeture du parc, incidents, ...), de votre maison (fuites, problèmes électriques, ...) et d'être informé de l'actualité culturelle de la Cité",
  'Notif question':
    'Souhaitez-vous recevoir des notifications, pour être informé ?',
  'Directory description': 'Un annuaire est présent sur cette application',
  'Directory question': 'Comment souhaitez-vous y apparaître ?',
  Interests: "Centre d'intérêt",
  'Interests description':
    'Afin de vous proposer des évènements culturels qui pourraient vous intéresser, pourriez-vous sélectionner au moins <b>3 thématiques</b> qui vous intéresse ? : ',
  Done: 'Configuration terminée !',
  'Done description':
    "Désormais, profitez de votre carte de résident, des <b>actualités et événements</b> du campus, de l'accès aux services (<b>sport, bibliothèque, santé, restauration,...</b>), de votre <b>espace maison, de l’annuaire</b>, ... et bien plus !",
  'My house committee': 'Comité de ma maison',
  'See all': 'Voir tout',
  'See results': 'Voir les résultats',
  'Reset filters': 'Réinitialiser le filtre',
  'No picture':
    'Aucune photo pour le profil sélectionné, veuillez prendre une photo.',
  'No cursus':
    "Tous les informations du cursus n'ont pas été sélectionné. Merci remplir tous les champs.",
  'Failed save data':
    "Échec de l'enregistrement des données de l'utilisateur, veuillez réessayer.",
  'Too few interests':
    "Trop peu d'intérêts sélectionnés. Merci d'en sélectionner au moins 3.",
  Reset: 'Réinitialiser',
  'Current house': 'Maison actuelle',
  'Emergency Contacts': "Contacts d'urgence",
  'No emergency number': "Aucun numéro d'urgence trouvé",
  'Phone numbers': 'Numéro de téléphone',
  'Email addresses': 'Adresses mail',
  Access: 'Accès',
  Reception: 'Accueil',
  'No places available': 'Pas de lieu disponible',
  'Add filter': 'Ajouter des filtres',
  'Apply filters': 'Appliquer les filtres',
  'Select all': 'Tout sélectionner',
  Itinerary: 'Itinéraire',
  'No user filtered': 'Aucun utilisateur ne correspond aux filtres',
  'See main invoice': 'Voir la facture principale',
  Invoices: 'Mes factures',
  Invoice: 'Facture',
  'No invoice': 'Pas de facture',
  'Additional parts': 'Pièces complémentaires',
  'File does not exist.': "Le fichier demandé n'existe pas.",
  'Digital services': 'Mes services numériques',
  'Campus services': 'Mes services du campus',
  'See the invoice': 'Voir la facture',
};

export default fr_FR;
